"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setServerFieldErrors = void 0;
const withDynamicTranslation_1 = require("./withDynamicTranslation");
/**
 * Shows server-side validation errors from an Inertia response on the matching Formik fields (GPAS-2569).
 * Error values are translation keys; errors for fields not on the form are shown on the fallback field,
 * so the client always sees a message instead of a silent failure.
 */
const setServerFieldErrors = ({ errors, setFieldError, translationKeys, fieldNames, replacements = {}, fallbackField = "amount", preferShortText = false, }) => {
    Object.entries(errors).forEach(([field, key]) => {
        const shortText = preferShortText ? translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys[`${key}Text`] : undefined;
        const fullText = (translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys[key]) ? (0, withDynamicTranslation_1.withDynamicTranslation)(translationKeys[key], replacements) : undefined;
        setFieldError(fieldNames.includes(field) ? field : fallbackField, shortText || fullText || (translationKeys === null || translationKeys === void 0 ? void 0 : translationKeys.genericErrorMessage) || key);
    });
};
exports.setServerFieldErrors = setServerFieldErrors;
